<template>
  <div>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.css"
    />
    <link
      rel="stylesheet"
      href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
      integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
      crossorigin="anonymous"
    />

    <aside class="content-wrapper">
      <section class="content fontstyle">
        <div style="font-size: 14px">
          <div class="row">
            <div class="col-12">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td valign="top" width="35%">
                    <table>
                      <tr>
                        <td style="font-size: 18px">
                          <b
                            style="font-weight: bold; text-transform: uppercase"
                            >{{ data.nama_perusahaan }}</b
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <span
                            class="smaller-text"
                            style="text-transform: uppercase"
                          >
                            {{
                              data.alamat_depo == null
                                ? 'MOHON MENGISI ALAMAT DEPO "' +
                                  data.nama_depo +
                                  '"'
                                : data.alamat_depo
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="smaller-text">
                            {{
                              data.kabupaten_depo == null
                                ? 'MOHON MENGISI KABUPATEN DEPO "' +
                                  data.nama_depo +
                                  '"'
                                : data.kabupaten_depo + " - BALI"
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="smaller-text">
                            {{
                              data.telp_depo == null
                                ? 'MOHON MENGISI NOMOR TELP DEPO "' +
                                  data.nama_depo +
                                  '"'
                                : "TELP. " + data.telp_depo
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="smaller-text">
                            {{
                              data.fax_depo == null
                                ? 'MOHON MENGISI FAX DEPO "' +
                                  data.nama_depo +
                                  '"'
                                : "FAX. " + data.fax_depo
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="data.npwp !== ''">
                        <td v-html="`N.P.W.P.: ${formatNpwp(data.npwp)}`"></td>
                      </tr>
                      <tr v-if="data.qr_url">
                        <qrcode-vue :width="115" :value="data.qr_url" />
                      </tr>
                    </table>
                  </td>
                  <td valign="top" width="40%" style="font-size: 16px">
                    <table>
                      <tr>
                        <td>KPD YTH</td>
                        <td>:</td>
                        <td>{{ data.nama_toko }}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          {{ data.alamat_toko }}
                        </td>
                      </tr>
                      <tr>
                        <td>ACCOUNT</td>
                        <td>:</td>
                        <td>{{ data.no_acc }}</td>
                      </tr>
                      <tr>
                        <td>PO</td>
                        <td>:</td>
                        <td>
                          {{ (data.po_manual == null || data.po_manual == ''
                            ? data.id
                            : data.po_manual) +
                            ' (' +
                            dFormat(data.tanggal, 'dMY') +
                            ')' }}
                        </td>
                      </tr>
                      <tr>
                        <td>SALESMAN</td>
                        <td>:</td>
                        <td>
                          {{ data.nama_tim + ' - ' + data.nama_salesman }}
                        </td>
                      </tr>
                      <tr>
                        <td>GUDANG</td>
                        <td>:</td>
                        <td>{{ data.gudang }}</td>
                      </tr>
                      <tr>
                        <td>NO. SALESMAN</td>
                        <td>:</td>
                        <td>{{ data.phone_salesman }}</td>
                      </tr>
                    </table>
                  </td>
                  <td valign="top" width="25%">
                    <table style="width: 100%; text-align: right">
                      <tr>
                        <td style="font-size: 20px">
                          <strong style="font-weight: bold">INVOICE</strong>
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 18px">
                          <strong style="font-weight: bold">{{ data.invoice }}</strong
                          >
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {{ data.hari != null ? data.hari.toUpperCase() : '' }} {{ data.minggu }}
                          {{ data.tgl_cetak }}
                        </td>
                      </tr>
                      <tr v-if="!hide_tanggal_tempo">
                        <td>JATUH TEMPO : {{ data.tgl_jatuh_tempo }}</td>
                      </tr>
                      <tr>
                        <td style="font-size: 18px">
                          <span
                            ><barcode
                              v-bind:value="data.id"
                              width="2"
                              displayValue="false"
                              height="30"
                              :flat="true"
                            ></barcode
                          ></span>
                          <strong
                            >{{ displayPaymentType(data.tipe_pembayaran)
                            }}{{
                              data.tipe_toko_3 == "RO" ? "-R" : "-N"
                            }}</strong
                          >
                        </td>
                      </tr>
                      <tr v-if="data.print_count && data.print_count > 0" style="font-size: 20px; font-weight: bold;">
                         REPRINT
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-12">
              <table style="width: 100%; font-size: 16px" class="table-border">
                <thead>
                  <tr class="text-center">
                    <th style="width: 3%">NO</th>
                    <th style="width: 10%">KODE</th>
                    <th style="width: 30%">NAMA BARANG</th>
                    <th style="width: 5%">JML</th>
                    <th style="width: 10%">HARGA</th>
                    <th style="width: 10%">DISK</th>
                    <th style="width: 10%">SUBTOTAL</th>
                  </tr>
                </thead>

                <tr
                  v-for="(row, i) in data.detail_penjualan"
                  :key="i"
                  class="detail"
                >
                  <td class="text-center">{{ i + 1 }}</td>
                  <td
                    class="text-left"
                    style="word-wrap: break-word; width: 10%"
                  >
                    <b>{{ row.kode_barang }}</b>
                  </td>
                  <td class="text-left">
                    {{ row.nama_barang }}
                  </td>
                  <td class="text-center">
                    <b>{{ row.qty + ' / ' + row.qty_pcs }}</b>
                  </td>
                  <td class="text-right">
                    {{  data.npwp !== ''
                      ? ribuan(row.harga)
                      : ribuan(row.harga_tax) }}
                  </td>
                  <td class="text-right">
                     {{  data.npwp !== ''
                       ? ribuan(row.discount)
                       : ribuan(row.discount_tax) }}
                  </td>
                  <td class="text-right">
                    {{ data.npwp !== ''
                      ? ribuan(row.subtotal)
                      : ribuan(row.subtotal_tax) }}
                  </td>
                </tr>

                <tr valign="top" class="footer">
                  <td
                    :rowspan="data.npwp === '' ? 3 : 5"
                    colspan="3"
                    style="border-top: 1px black solid"
                  >
                    <span v-if="data.npwp === ''">
                      Harga sudah termasuk PPn
                    </span>
                    <br v-if="data.npwp === ''" />
                    {{ data.terbilang }}
                    <br />
                    Catatan: {{ data.keterangan }}
                    <br />
                    Kritik & saran : {{ data.no_koordinator }}. Batas komplain 1 x 24 jam penerimaan barang!
                    <br />

                  </td>
                  <td
                    class="text-center no-bottom"
                    style="border-top: 1px black solid"
                  >
                    Total
                  </td>
                  <td
                    colspan="2"
                    class="no-bottom"
                    style="border-top: 1px black solid"
                  >
                    SUBTOTAL
                  </td>
                  <td
                    class="text-right no-bottom"
                    style="border-top: 1px black solid"
                  >
                    {{ data.npwp !== ''
                      ? ribuan(data.subtotal)
                      : ribuan(data.subtotal_tax) }}
                  </td>
                </tr>
                <tr colspan="2" class="footer">
                  <td class="text-center no-top no-bottom">
                    <b>{{ data.total_qty + ' / ' + data.total_pcs }}</b>
                  </td>
                  <td colspan="2" class="no-top no-bottom no-right">DISKON</td>
                  <td
                    class="text-right no-top no-bottom no-left"
                  >
                    {{ data.npwp !== ''
                      ? ribuan(data.diskon)
                      : ribuan(data.diskon_tax) }}
                  </td>
                </tr>
                <tr colspan="2" class="footer" v-if="data.npwp !== ''">
                  <td class="no-top no-bottom"></td>
                  <td colspan="2" class="no-top no-bottom">DPP</td>
                  <td
                    class="text-right no-top no-bottom"
                  >
                  {{ ribuan(data.grand_total - data.ppn) }} 
                </td>
              </tr>
              <tr v-if="data.npwp !== ''" colspan="2" class="footer">
                <td class="no-top no-bottom"></td>
                <td colspan="2" class="no-top no-bottom">PPn</td>
                <td class="text-right no-top no-bottom">
                  {{ ribuan(data.ppn) }}
                  </td>
                </tr>
                <tr colspan="2" class="footer">
                  <td class="no-top bottom"></td>
                  <td colspan="2" class="no-top bottom"><b>GRAND TOTAL</b></td>
                  <td class="text-right no-top bottom">
                    <b>{{ ribuan(data.grand_total) }}</b>
                  </td>
                </tr>
              </table>
            </div>
            <section id="payment-info" class="row" v-if="data.rekenings && data.rekenings.length > 0">
              <div class="col" v-for="(rekening, index) in data.rekenings">
                <h6 class="m-0 px-1 py-1 font-weight-bold">Pembayaran Via Transfer dapat melalui</h6>
                <div class="col-12 px-1 font-weight-bold">
                  <div class="row">
                    <div class="col-4">Bank</div>
                    <div class="col-7"> {{ `: ${rekening.nama_bank}` }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">Cabang</div>
                    <div class="col-7"> {{ `: ${rekening.cabang_bank}` }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">No Rekening</div>
                    <div class="col-7"> {{ `: ${rekening.nomor_rekening}` }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">Atas Nama</div>
                    <div class="col-7"> {{ `: ${rekening.nama_pemilik_rekening}` }}</div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="col-12">
              <table class="text-center" style="width: 100%">
                <tr valign="top" style="height: 50px">
                  <td width="20%">Bag. Invoice</td>
                  <td width="20%">Spv. Sales</td>
                  <td width="20%">Bag. Gudang</td>
                  <td width="20%">Pengirim</td>
                  <td width="20%">Penerima</td>
                </tr>
                <tr>
                  <td>( {{ auth.name == null ? '' : auth.name }} )</td>
                  <td>(<span style="padding-left: 70%">)</span></td>
                  <td>(<span style="padding-left: 70%">)</span></td>
                  <td>(<span style="padding-left: 70%">)</span></td>
                  <td>(<span style="padding-left: 70%">)</span></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </section>
    </aside>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";

export default {
  name: "PrintInvoice",
  mixins: [helper],
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },

  data() {
    return {
      data: {
        subtotal: 0,
        diskon: 0,
        ppn: 0,
        grand_total: 0,
      },
      link_maps: "",
      hide_tanggal_tempo: false,
      auth: {},
    };
  },

  methods: {
    getData() {
      let invoice = JSON.parse(localStorage.invoiceItems),
      data = invoice.data;
      data.print_count = localStorage.printCountInoivce
      if (data.latitude !== 0 && data.longitude !== 0) {
        this.link_maps =
          "https://www.google.com/maps?q=" +
          data.latitude +
          "," +
          data.longitude +
          "&z=17&hl=id";
      }
      this.data = data;

      const regex = new RegExp("MT|D1|CA1|AB2|A1|SMTE");

      this.hide_tanggal_tempo = regex.test(data.nama_tim);

      document.title = "INVOICE " + data.id + " - PRINT";
      setTimeout(() => {
        window.print();
      }, 500);
    },
  },

  mounted() {
    this.auth = JSON.parse(localStorage.user);
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.body {
  font-family: "Times New Roman", Helvetica, sans-serif;
}
.content-wrapper {
  display: block;
  background-color: #ecf0f5;
}
.content {
  min-height: 250px;
  padding: 15px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.table-border {
  table-layout: fixed;
}

.table-border tr td {
  padding: 3px;
}

.table-border tr th {
  padding: 5px;
  border: solid 1px black;
}

.content.fontstyle {
  font-family: Times New Roman, Helvetica, sans-serif;
  font-weight: 400;
}

.smaller-text {
  font-size: 14px;
}

.no-bottom {
  border-bottom: none !important;
}

.no-top {
  border-top: none !important;
}

.no-left {
  border-left: none !important;
}

.no-right {
  border-right: none !important;
}

tr.footer {
  border: none;
  font-weight: bold;
}

tr.footer td {
  padding-bottom: 2px !important;
  padding-top: 2px !important;
}

@media print {
  .table-border {
    border: solid 1px black !important;
  }
  .bottom {
    border-bottom: solid 1px black !important;
  }
  .content {
    margin: 5px;
  }
}
</style>
